<template>
  <MobileCategoryMenu
    v-if="content.route === 'category'"
    :content="content"
    :style="navItemStyle"
  />
  <LangRouterLink
    :to="{ name: content.route }"
    v-else
    class="navbar__bottom-item"
    :style="navItemStyle"
    :title="$t(`navigation.${content.route}`)"
  >
    <span class="navbar__bottom-item-label">{{ $t(`navigation.${content.route}`) }}</span>
  </LangRouterLink>
</template>

<script>
import { LangRouterLink } from '@/components/global'
import MobileCategoryMenu from '@/components/navigation/MobileCategoryMenu.vue'

export default {
  name: 'MobileMenuItem',
  props: {
    content: {
      type: Object,
      required: true,
    },
    enterDelay: {
      type: Number,
      default: 0,
    },
  },
  components: { LangRouterLink, MobileCategoryMenu },
  computed: {
    navItemStyle() {
      return { '--nav-item-delay': `${this.enterDelay}ms` }
    },
  },
}
</script>
